<template>
  <div class="menu-container">
    <MenuSection :listItems="getAppetisers" />
    <MenuSection :listItems="getSoups" />
    <MenuSection :listItems="getMandarin" />
    <MenuSection :listItems="getKungPo" />
    <MenuSection :listItems="getSichuan" />
    <MenuSection :listItems="getBlackPepper" />
    <MenuSection :listItems="getBlackBean" />
    <MenuSection :listItems="getHoneyChilli" />
    <MenuSection :listItems="getHoneyGarlic" />
    <MenuSection :listItems="getSweetChilli" />
    <MenuSection :listItems="getSatay" />
    <MenuSection :listItems="getChicken" />
    <MenuSection :listItems="getBeef" />
    <MenuSection :listItems="getKingPrawn" />
    <MenuSection :listItems="getRoastDuck" />
    <MenuSection :listItems="getCharSiu" />
    <MenuSection :listItems="getSweetAndSour" />
    <MenuSection :listItems="getCurry" />
    <MenuSection :listItems="getFooYoung" />
    <MenuSection :listItems="getFriedRice" />
    <MenuSection :listItems="getChowMein" />
    <MenuSection :listItems="getEuropean" />
    <MenuSection :listItems="getSideDishes" />
    <MenuSection :listItems="getUdon" />
    <MenuSection :listItems="getSnackBox" />
    <MenuSection :listItems="getMunchyBox" />
  </div>
</template>

<script>
import MenuSection from "./MenuSection.vue";
import { mapGetters } from "vuex";

export default {
  name: "MenuList",
  components: {
    MenuSection,
  },
  computed: mapGetters([
    "getAppetisers",
    "getSoups",
    "getMandarin",
    "getKungPo",
    "getSichuan",
    "getBlackPepper",
    "getBlackBean",
    "getHoneyChilli",
    "getHoneyGarlic",
    "getSweetChilli",
    "getSatay",
    "getChicken",
    "getBeef",
    "getKingPrawn",
    "getRoastDuck",
    "getCharSiu",
    "getSweetAndSour",
    "getCurry",
    "getFooYoung",
    "getFriedRice",
    "getChowMein",
    "getEuropean",
    "getSideDishes",
    "getUdon",
    "getSnackBox",
    "getMunchyBox",
  ]),
};
</script>

<style scoped>
.menu-container {
  width: 100%;
  column-count: 2;
  column-gap: 0;
}

@media screen and (max-width: 767px) {
  .menu-container {
    column-count: 1;
  }
}
</style>
